<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><i>For BB, the biggest risk I ever took.</i></div>
<div class="ctag1"><i>Kimmie</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// held_9781118000229_oeb_ded_r1.vue?55e67cd7